import axios from "axios";
import { getToken, getTokenHeader } from "../../../../../screen/auth/action";
import { createEPinUrl, registerUrl, sendOtpUrl, verifyOtpUrl } from "../urls";

export const sendOTPAction = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(
        `${sendOtpUrl()}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: true, message: err.response?.data?.message || err.message });
      });
  });
};
export const verifyOTPAction = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(
        `${verifyOtpUrl()}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: true, message: err.response?.data?.message || err.message });
      });
  });
};
export const creteEPinAction = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(
        `${createEPinUrl()}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: true, message: err.response?.data?.message || err.message });
      });
  });
};
export const registerAction = async (data, token) => {
  return new Promise(async (next) => {
    const authToken = token || await getToken();
    await axios
      .post(
        `${registerUrl()}`,
        data,
        getTokenHeader(authToken),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: true, message: err.response?.data?.message || err.message });
      });
  });
};